/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityKeyAIcon16Light } from './SecurityKeyAIcon16Light';
import { SecurityKeyAIcon16Regular } from './SecurityKeyAIcon16Regular';
import { SecurityKeyAIcon16Solid } from './SecurityKeyAIcon16Solid';
import { SecurityKeyAIcon20Light } from './SecurityKeyAIcon20Light';
import { SecurityKeyAIcon20Regular } from './SecurityKeyAIcon20Regular';
import { SecurityKeyAIcon20Solid } from './SecurityKeyAIcon20Solid';
import { SecurityKeyAIcon24Regular } from './SecurityKeyAIcon24Regular';
import { SecurityKeyAIcon24Solid } from './SecurityKeyAIcon24Solid';
import { SecurityKeyAIcon32Regular } from './SecurityKeyAIcon32Regular';
import { SecurityKeyAIcon64Regular } from './SecurityKeyAIcon64Regular';
var sizes = {
    16: {
        light: SecurityKeyAIcon16Light,
        regular: SecurityKeyAIcon16Regular,
        solid: SecurityKeyAIcon16Solid,
    },
    20: {
        light: SecurityKeyAIcon20Light,
        regular: SecurityKeyAIcon20Regular,
        solid: SecurityKeyAIcon20Solid,
    },
    24: {
        regular: SecurityKeyAIcon24Regular,
        solid: SecurityKeyAIcon24Solid,
    },
    32: {
        regular: SecurityKeyAIcon32Regular,
    },
    64: {
        regular: SecurityKeyAIcon64Regular,
    },
};
export var SecurityKeyAIcon = forwardRef('SecurityKeyAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
